exports.responseHandler = async (input, callback) => {

    const email = input.message;

    try {
        const resp = await axios.get("https://hook.us1.make.com/aoizn8svj4yhzatlf4dbbushjrvg7kwn?e-mail=" + email);
        const cliente = resp && resp.data

        if (cliente.ativo == "true") {
            callback([{
                "message": `E-mail verificado com sucesso ${cliente.nome.split(" ")[0]}, por favor clique no botão abaixo para concluir o seu agendamento:`,
                "platform": "kommunicate",
                "metadata": {
                    "contentType": "300",
                    "templateId": "3",
                    "payload": [{
                        "type": "link",
                        "name": "Concluir agendamento",
                        "url": "https://calendly.com/daumhelp/atendimento?email=" + cliente.email + "&name=" + cliente.nome,
                    }]
                }
            }, {
                "platform": "kommunicate",
                "metadata": {
                    "actionRequest": "updateUserDetail",
                    "payload": {
                        "email": cliente.email,
                        "displayName": cliente.nome,
                        "phoneNumber": cliente.telefone,
                        "name": cliente.nome
                    }
                }
            }
            ])
        }

        if (cliente.ativo == "") {
            callback([{
                "message": "Para agendar atendimento é necessário realizar a assinatura de nossos serviços, clicando no botão abaixo:",
                "metadata": {
                    "contentType": "300",
                    "templateId": "3",
                    "payload": [{
                        "name": "Assinar Suporte Remoto Ilimitado",
                        "type": "link",
                        "url": "https://portal.daumhelp.online/b/eVa6r5cqM1Pw6u44gg?s=pli&prefilled_email=" + email
                    }]
                }
            }])
        }

        if (cliente.ativo == "false") {
            callback([{
                "message": `Olá ${cliente.nome} para regularizar sua assinatura acesse:`,
                "metadata": {
                    "contentType": "300",
                    "templateId": "3",
                    "payload": [{
                        "type": "link",
                        "name": "Portal de pagamentos",
                        "url": "https://portal.daumhelp.online/b/eVa6r5cqM1Pw6u44gg?s=pli&prefilled_email=" + email
                    }]
                }
            }])
        }

    } catch (error) {
        const errorMsg = error.message;
        callback([{ "message": "Houve um erro " + errorMsg }]);
    }
}